const valueContains = (value, query) => {
  if (value === null || value === undefined) return false;
  if (Array.isArray(value)) {
    return value.some((item) => valueContains(item, query));
  }
  if (typeof value === "object") {
    return Object.values(value).some((item) => valueContains(item, query));
  }
  return String(value).toLocaleLowerCase().includes(query);
};

export const filterReportRows = (rows, search) => {
  const query = String(search || "").trim().toLocaleLowerCase();
  if (!query) return Array.isArray(rows) ? rows : [];
  return (Array.isArray(rows) ? rows : []).filter((row) =>
    valueContains(row, query)
  );
};
